/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseDeleteGalleryImage } from '../../models/response-delete-gallery-image';

export interface DeleteActivityGalleryImageById$Params {
  activityId: number;
  id: number;
}

export function deleteActivityGalleryImageById(http: HttpClient, rootUrl: string, params: DeleteActivityGalleryImageById$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDeleteGalleryImage>> {
  const rb = new RequestBuilder(rootUrl, deleteActivityGalleryImageById.PATH, 'delete');
  if (params) {
    rb.path('activityId', params.activityId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseDeleteGalleryImage>;
    })
  );
}

deleteActivityGalleryImageById.PATH = '/rest/activity/{activityId}/gallery/{id}';
